module.exports = __webpack_public_path__ + "static/media/icon_service_01_pc.dc73f399.webp";